export const RENDER_MAIN_UI = 'buildYourOdds.ui.renderMainUi';
export const UI_READY = 'buildYourOdds.ui.ready';
export const OPEN_BUILD_YOUR_ODDS_EVENT = 'wh.sports.buildYourOdds.open.event';
export const OPEN_BUILD_YOUR_ODDS_MODAL = 'openBuildYourOddsModal';
export const CLOSE_BUILD_YOUR_ODDS_MODAL = 'closeBuildYourOddsModal';
export const GET_ODDS_FORMAT = 'onOddsFormatChanged';
export const EDIT_BUILD_YOUR_ODDS_SELECTION = 'wh.sports.buildYourOdds.edit.selection';
export const SESSION_STATE_NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const SESSION_STATE_LOGGED_IN = 'LOGGED_IN';
export const BYO_MARKET_NO_ROWS = 1000;
export const START_NEW_LOGIN_PROCESS = 'wh.common.command.ui.login.flow.start';
export const BYO_CAMPAIGN_QUERY_PARAM = 'byo';
export const PUSH_SUBSCRIBE_OWNER = 'byo-modal';
export const ERRORS = {
    BYO_GENERIC_ERROR: 'BYO_GENERIC_ERROR',
};
export const BYO_NGS_RESOURCE_NAME = 'sb-build-yourodds';
export const BYO_FAVOURITES_STORAGE_KEY = 'WH::SB:BYO:favourites';
export const MB_ANALYTICS_ADAPTER_READY = 'wh.analytics.adapter.ready';
export const MB_ANALYTICS_PARTIAL_EVENT = 'wh.common.command.dli.tl.eventPartial';
export const MB_FEATURE_FLAG_ACTIVATE_EXPERIMENT = 'sb.featureFlag.activateExperiment';
export const MB_ANALYTICS_FEATURE_FLAG_TRACK_EVENT = 'wh.analytics.featureFlag.trackEvent';
export const OPTIMIZELY_BYO_FAVOURITES_EXPERIMENT_KEY = 'byo_favourites';
export const OPTIMIZELY_BYO_VARIATION_KEY = 'variation_1';
export const OPTIMIZELY_ADD_FAVOURITE_EVENT_KEY = 'add_favourite_byo_market';
export const GET_FEATURE_FLAG = 'sb.featureFlag.getFeatureFlag';
export const NATIVE_CLOSE_DRAWER = 'betslip.closeDrawers';
export const CATEGORIES = {
    RESULT: 'RESULT',
    BOTH_TEAMS_TO_SCORE: 'BOTH_TEAMS_TO_SCORE',
    TOTAL_GOALS: 'TOTAL_GOALS',
    TOTAL_GOAL_KICKS: 'TOTAL_GOAL_KICKS',
    TOTAL_CARDS: 'TOTAL_CARDS',
    TOTAL_CORNERS: 'TOTAL_CORNERS',
    CORRECT_SCORE: 'CORRECT_SCORE',
    DOUBLE_CHANCE: 'DOUBLE_CHANCE',
    TEAM_WITH_MOST_CORNERS: 'TEAM_WITH_MOST_CORNERS',
    PLAYER_TO_SCORE: 'PLAYER_TO_SCORE',
    PLAYER_TO_SCORE_OUTSIDE_BOX: 'PLAYER_TO_SCORE_OUTSIDE_BOX',
    PLAYER_TO_SCORE_A_HEADER: 'PLAYER_TO_SCORE_A_HEADER',
    PLAYER_TO_SCORE_LEFT_FOOT: 'PLAYER_TO_SCORE_LEFT_FOOT',
    PLAYER_TO_SCORE_RIGHT_FOOT: 'PLAYER_TO_SCORE_RIGHT_FOOT',
    PLAYER_TO_SCORE_A_FREE_KICK: 'PLAYER_TO_SCORE_A_FREE_KICK',
    PLAYER_TO_SCORE_INSIDE_6_YARD_BOX: 'PLAYER_TO_SCORE_INSIDE_6_YARD_BOX',
    TEAM_WITH_MOST_CARDS: 'TEAM_WITH_MOST_CARDS',
    DOUBLE_RESULT: 'DOUBLE_RESULT',
    PLAYER_TO_BE_CARDED: 'PLAYER_TO_BE_CARDED',
    FIRST_TEAM_TO_SCORE: 'FIRST_TEAM_TO_SCORE',
    COME_FROM_BEHIND: 'COME_FROM_BEHIND',
    TOTAL_BOOKING_POINTS: 'TOTAL_BOOKING_POINTS',
    TEAM_WITH_MOST_BOOKING_POINTS: 'TEAM_WITH_MOST_BOOKING_POINTS',
    MATCH_HANDICAP: 'MATCH_HANDICAP',
    TOTAL_FREE_KICKS: 'TOTAL_FREE_KICKS',
    TOTAL_THROW_INS: 'TOTAL_THROW_INS',
    HIGHEST_SCORING_HALF: 'HIGHEST_SCORING_HALF',
    RED_CARD: 'RED_CARD',
    QUALIFY_LIFT_THE_TROPHY: 'QUALIFY_LIFT_THE_TROPHY',
    PLAYER_TO_ASSIST: 'PLAYER_TO_ASSIST',
    PLAYER_SHOTS_ON_TARGET: 'PLAYER_SHOTS_ON_TARGET',
    METHOD_OF_GOAL: 'METHOD_OF_GOAL',
    PLAYER_TOTAL_SHOTS: 'PLAYER_TOTAL_SHOTS',
    PLAYER_TACKLES: 'PLAYER_TACKLES',
    PLAYER_TOTAL_TACKLES: 'PLAYER_TOTAL_TACKLES',
    MATCH_TO_GO_PENALTIES: 'MATCH_TO_GO_TO_PENALTIES',
    TO_WIN_ON_PENALTIES: 'TO_WIN_ON_PENALTIES',
    TOTAL_TACKLES: 'TOTAL_TACKLES',
    TOTAL_SHOTS: 'TOTAL_SHOTS',
    TO_WIN_IN_EXTRATIME: 'TO_WIN_IN_EXTRATIME',
    TOTAL_SHOTS_ON_TARGET: 'TOTAL_SHOTS_ON_TARGET',
    METHOD_OF_GOAL_HOW: 'METHOD_OF_GOAL_HOW',
    METHOD_OF_GOAL_WHERE: 'METHOD_OF_GOAL_WHERE',
    QUALIFY: 'QUALIFY',
    POINTS_HANDICAP: 'POINTS_HANDICAP',
    MONEY_LINE: 'MONEY_LINE',
    TOTAL_POINTS: 'TOTAL_POINTS',
    BLOCKS: 'BLOCKS',
    STEALS: 'STEALS',
    TURNOVERS: 'TURNOVERS',
    BLOCKS_STEALS: 'BLOCKS_STEALS',
    THREE_MADE: 'THREE_MADE',
    ASSISTS: 'ASSISTS',
    REBOUNDS: 'REBOUNDS',
    ASSISTS_REBOUNDS: 'ASSISTS_REBOUNDS',
    POINTS: 'POINTS',
    POINTS_ASSISTS: 'POINTS_ASSISTS',
    POINTS_REBOUNDS: 'POINTS_REBOUNDS',
    POINTS_ASSISTS_REBOUNDS: 'POINTS_ASSISTS_REBOUNDS',
};
